/**
 * 监控平台底部面板-设备状态一览
 * 创建时间：2017-07-10
 *   创建人：Shujuan Sun
 */
<template>
	<div class="position_r ">
	<div id="vehicle-device" v-loading="loadList" element-loading-text="加载中" style="width:630px;fontSize:12px;">
		<div class="vehicle-device-header">       
            <h4 class="ui-modal__header-text">{{vehicleDInfo.carNo}}&nbsp;|&nbsp;{{vehicleDInfo.vAcc}}&nbsp;设备状态一览</h4>
            <button type="button" class="close" @click="closeComp"><span >&times;</span></button>
        </div>
        <div class="device_table_box">
        	<table class="table table-bordered">
				<thead>
					<tr>
						<th>设备ID</th>
						<th>设备编码</th>
						<th>SIM卡号</th>
						<th>类型</th>
						<th v-show="showPowerStr">电量</th>
						<th>定位</th>
						<th>状态详情</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(device,index) in deviceList">
						<td>VD{{device.deviceId}}</td>
						<td>{{device.deviceNum}}</td>
						<td>{{device.simNum}}</td>
						<td>{{device.wifiFlagStr}}</td>
						<td v-show="showPowerStr" :class="{red:device.wifiFlagStr==='无线' && device.power < 20}">{{device.power}}%</td>
						<td>{{device.locModeStr}}</td>
						<td>{{device.status}}</td>
					</tr>
				</tbody>
			</table>
        </div>
		
	</div>
	</div>
</template>

<script>
	export default {
		name: 'VehicleDevice',
		data() {
			return {
				deviceList:[],
				loadList:false,
				showPowerStr:false
			};
		},
		computed:{
		  	vehicleDInfo(){
		  		return this.$store.state.monitor.vehicleDInfo
		  	}
		},
		watch:{
			'vehicleDInfo.vId'(val){
				const that = this
				this.getDeviceData(val)
			}
		},
		beforeMount(){
			const that = this
			this.getDeviceData(that.vehicleDInfo.vId)
		},
		beforeDestroy(){
			this.$store.dispatch('closeDeviceList')
		},
		methods:{
			getDeviceData(id){
				this.loadList = true
				this.$http.get(process.env.API_ROOT + '/monitor/vehicle/' + id + '/devices')
				.then(res=>{
					this.deviceList = res.body.data
					let hasBK200 = this.deviceList.filter(item=>item.wifiFlagStr=='无线') 
					if(hasBK200.length>0){
						this.showPowerStr = true;
					}else{
						this.showPowerStr = false;
					}
					this.loadList = false
				},res=>{
					this.$store.dispatch('tipModalShow',res.body.message)
					this.loadList = false
				})
				.catch(res=>{ 
					this.$store.dispatch('tipModalShow','请求异常')
					this.loadList = false
				})
			},
			closeComp(){
				this.$store.dispatch('closeDeviceList')
			}
		}
		
	};
</script>



// WEBPACK FOOTER //
// VehicleDevice.vue?3fb490f8